import { Construction, Mail } from "lucide-react";

const MaintenanceMode = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary via-primary/90 to-primary/80 flex items-center justify-center p-6">
      <div className="max-w-lg text-center text-white">
        {/* Logo / Brand */}
        <h1 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight">
          DocuRapid
        </h1>
        
        {/* Construction Icon */}
        <div className="mb-8">
          <Construction className="w-24 h-24 mx-auto opacity-90 animate-pulse" />
        </div>
        
        {/* Main Message */}
        <h2 className="text-2xl md:text-3xl font-semibold mb-4">
          Site în Construcție
        </h2>
        
        <p className="text-lg md:text-xl opacity-90 mb-8 leading-relaxed">
          Lucrăm la ceva special pentru tine.<br />
          Revenim în curând cu servicii rapide de documente oficiale!
        </p>
        
        {/* Divider */}
        <div className="w-24 h-1 bg-white/30 mx-auto mb-8 rounded-full" />
        
        {/* Contact */}
        <div className="flex items-center justify-center gap-2 text-white/80 hover:text-white transition-colors">
          <Mail className="w-5 h-5" />
          <a 
            href="mailto:contact@docurapid.ro" 
            className="underline underline-offset-4"
          >
            contact@docurapid.ro
          </a>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceMode;
